import {AfterViewInit, Directive, ElementRef, Output} from '@angular/core';

@Directive({
  selector: '[appTooltipOnOverflow]',
  exportAs: 'isDisabledTooltip',
  standalone: true
})
export class TooltipOnOverflowDirective implements AfterViewInit {
  element: ElementRef;
  @Output() isDisabledTooltip = false;

  constructor(el: ElementRef) {
    this.element = el;
  }

  ngAfterViewInit() {
    this.isDisabledTooltip = !(
      this.element.nativeElement.offsetWidth < this.element.nativeElement.scrollWidth
    );
  }
}
